// Import React, styles, SVG icons, and navigation hook
import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Footer component displays contact info, social links, and legal disclaimers.
 */
function Footer() {
  // useNavigate hook for client-side navigation
  const navigate = useNavigate();
  return (
    <footer className="background-container  bg-gray-3" id="contact">
      <div className="background-container  bg-primary-1">
        <div className="content-container  py-xl px-xxxl">
          <div className=" column align-center gap-l">
            <div className="body1">
              Monk Financial Planning is a trading style of Rosemount Financial
              Solutions (IFA) Limited, which is authorised and regulated by the
              Financial Conduct Authority. Rosemount Financial Solutions (IFA)
              Ltd is entered on the Financial Services Register under reference
              535515. Registered in England and Wales (Company Number:
              05668905). Registered Address: Rosemount House, 2–4 Chequers Road,
              Basingstoke, RG21 7PU. The information on this website is subject
              to the UK regulatory regime and is intended for consumers in the
              UK.
              {/*
            <a
              href="https://register.fca.org.uk/s/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "underline" }}
            >
              (https://register.fca.org.uk/s/)
            </a>
            under reference 535515. Rosemount Financial Solutions (IFA) Ltd is
            authorised and regulated by the Financial Conduct Authority.
          */}
            </div>

            <div className="body1">
              Read the{" "}
              <span
                className="body1"
                onClick={() => navigate("/privacy-policy")}
                style={{ cursor: "pointer", textDecoration: "underline" }}
              >
                Privacy Policy
              </span>{" "}
              here.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

// Export the Footer component as default
export default Footer;
